import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=dafff12c&scoped=true&"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodSelector.vue?vue&type=style&index=0&id=dafff12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafff12c",
  null
  
)

export default component.exports